export const CHANGE_VIEW = 'CHANGE_VIEW'
export const CHANGE_CHART_CONFIGURATION = 'CHANGE_CHART_CONFIGURATION'
export const UPDATE_MODE = 'UPDATE_MODE'
